import React from "react";
import Loader from "@amzn/meridian/esm/components/loader";
import {Column, Row, Theme} from "@amzn/meridian";
import aimsTheme from "../../meridian-theme-aims.json";

// Loading view
const Loading = () => {
  return (
    <Column spacing="none" spacingInset="none">
      <Column height="104px" />
      <Column height="64px">
        <Row spacing="none" spacingInset="none">
          <Row width="153px"/>
          <Theme palette={aimsTheme}>
            <Loader />
          </Theme>
        </Row>
      </Column>
    </Column>
  );
};
export default Loading;
